import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { PARTNER_NAME_MAX_LENGTH } from '@bridebook/toolbox/src/validation/partner-names/const';

export const getPartnerNameErrorMessages = () => ({
  required: getI18n().t('common:validation.partnerName.tooShort'),
  tooLong: getI18n().t('common:validation.partnerName.tooLong', {
    maxLength: PARTNER_NAME_MAX_LENGTH,
  }),
  containsNumbers: getI18n().t('common:validation.partnerName.containsNumbers'),
  containsInvalidCharacters: getI18n().t('common:validation.partnerName.containsInvalidCharacters'),
  invalid: getI18n().t('common:validation.partnerName.invalid'),
});
